import React from 'react';

const LogoIcon = ({ 
  width = 118,
  height = 35,
  color = "currentColor",
  className = "",
  ...props 
}) => {
  const scale = Math.min(width / 118, height / 35);
  const viewBoxWidth = 118 / scale;
  const viewBoxHeight = 35 / scale;
  
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g clipPath="url(#clip0_1450_267)">
        <path 
          d="M111.529 6.9336C113.336 6.86312 114.973 7.53954 116.194 8.75618C117.357 9.91542 118 11.4295 118 13.3606L117.998 28.0817H112.338L102.05 28.0583C100.246 28.0589 98.6125 27.3329 97.4302 26.159C96.2478 24.9851 95.5164 23.3634 95.5164 21.5719C95.5164 19.7806 96.2478 18.1584 97.4302 16.9845C98.6125 15.8106 100.246 15.0845 102.05 15.0845L113.758 15.1069V11.1443H99.4019V6.9336H111.529H111.529ZM102.036 19.3147C98.9509 19.4229 98.86 23.7688 102.097 23.8836L113.76 23.8714V19.3148H102.036V19.3147Z" 
          fill={color}
        />
        <path 
          d="M0 10.4506L0.0412187 0.000488281H4.27346L4.27907 13.7578L18.3372 0.000488281L24.3753 0.00639986L9.90485 14.1651L23.8065 27.995L17.9095 28.0593L5.87858 16.1485C5.28572 15.6059 4.27438 15.9869 4.27438 16.8921V28.0591H0.0412187L0.0419056 19.1048C0.0840403 17.7639 1.2756 16.6395 2.4619 15.52L3.8291 14.2002L0 10.4503L0 10.4506Z" 
          fill={color}
        />
        <path 
          d="M40.1241 6.9336C41.9309 6.86312 43.5679 7.53954 44.7888 8.75618C45.952 9.91542 46.5951 11.4295 46.5952 13.3606L46.5928 28.0817H40.9329L30.6452 28.0583C28.8411 28.0589 27.2076 27.3329 26.0253 26.159C24.8429 24.9851 24.1116 23.3634 24.1116 21.5719C24.1116 19.7806 24.8429 18.1584 26.0253 16.9845C27.2076 15.8106 28.8411 15.0845 30.6452 15.0845L42.3532 15.1069V11.1443H27.997V6.9336H40.1242H40.1241ZM30.6309 19.3147C27.5462 19.4229 27.4552 23.7688 30.6926 23.8836L42.355 23.8714V19.3148H30.6308L30.6309 19.3147Z" 
          fill={color}
        />
        <path 
          d="M66.4144 6.93454C69.7854 6.98673 72.4231 9.48573 72.6145 12.8305C72.6145 15.9026 72.7828 19.1498 72.6477 22.1761C72.5824 25.5962 69.6591 28.2261 66.0341 28.0846H55.4875V35H51.2542V6.9342L66.4144 6.93466V6.93454ZM55.4875 27.4817L59.1415 23.8455H68.3905L68.4149 12.2619C68.4168 11.3101 67.6003 11.186 66.8286 11.1442L55.4874 11.1438V27.4817H55.4875Z" 
          fill={color}
        />
        <path 
          d="M81.4711 21.5958L81.4708 11.0553H74.5903V6.85232H81.4706L81.4704 0L85.7038 0.0239874V6.85232H92.5835V11.0553H85.7038V23.8943L92.5427 23.8723V28.0828L88.222 28.0763C84.3842 28.0701 81.3564 25.5226 81.471 21.5958H81.4711Z" 
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1450_267">
          <rect width="118" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// Optional: Create a simplified version with proper aspect ratio
const LogoIconSimple = ({ 
  width = 118,
  height = 35,
  color = "currentColor",
  className = "",
  ...props 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 118 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M111.529 6.9336C113.336 6.86312 114.973 7.53954 116.194 8.75618C117.357 9.91542 118 11.4295 118 13.3606L117.998 28.0817H112.338L102.05 28.0583C100.246 28.0589 98.6125 27.3329 97.4302 26.159C96.2478 24.9851 95.5164 23.3634 95.5164 21.5719C95.5164 19.7806 96.2478 18.1584 97.4302 16.9845C98.6125 15.8106 100.246 15.0845 102.05 15.0845L113.758 15.1069V11.1443H99.4019V6.9336H111.529H111.529ZM102.036 19.3147C98.9509 19.4229 98.86 23.7688 102.097 23.8836L113.76 23.8714V19.3148H102.036V19.3147Z" 
        fill={color}
      />
      <path 
        d="M0 10.4506L0.0412187 0.000488281H4.27346L4.27907 13.7578L18.3372 0.000488281L24.3753 0.00639986L9.90485 14.1651L23.8065 27.995L17.9095 28.0593L5.87858 16.1485C5.28572 15.6059 4.27438 15.9869 4.27438 16.8921V28.0591H0.0412187L0.0419056 19.1048C0.0840403 17.7639 1.2756 16.6395 2.4619 15.52L3.8291 14.2002L0 10.4503L0 10.4506Z" 
        fill={color}
      />
      <path 
        d="M40.1241 6.9336C41.9309 6.86312 43.5679 7.53954 44.7888 8.75618C45.952 9.91542 46.5951 11.4295 46.5952 13.3606L46.5928 28.0817H40.9329L30.6452 28.0583C28.8411 28.0589 27.2076 27.3329 26.0253 26.159C24.8429 24.9851 24.1116 23.3634 24.1116 21.5719C24.1116 19.7806 24.8429 18.1584 26.0253 16.9845C27.2076 15.8106 28.8411 15.0845 30.6452 15.0845L42.3532 15.1069V11.1443H27.997V6.9336H40.1242H40.1241ZM30.6309 19.3147C27.5462 19.4229 27.4552 23.7688 30.6926 23.8836L42.355 23.8714V19.3148H30.6308L30.6309 19.3147Z" 
        fill={color}
      />
      <path 
        d="M66.4144 6.93454C69.7854 6.98673 72.4231 9.48573 72.6145 12.8305C72.6145 15.9026 72.7828 19.1498 72.6477 22.1761C72.5824 25.5962 69.6591 28.2261 66.0341 28.0846H55.4875V35H51.2542V6.9342L66.4144 6.93466V6.93454ZM55.4875 27.4817L59.1415 23.8455H68.3905L68.4149 12.2619C68.4168 11.3101 67.6003 11.186 66.8286 11.1442L55.4874 11.1438V27.4817H55.4875Z" 
        fill={color}
      />
      <path 
        d="M81.4711 21.5958L81.4708 11.0553H74.5903V6.85232H81.4706L81.4704 0L85.7038 0.0239874V6.85232H92.5835V11.0553H85.7038V23.8943L92.5427 23.8723V28.0828L88.222 28.0763C84.3842 28.0701 81.3564 25.5226 81.471 21.5958H81.4711Z" 
        fill={color}
      />
    </svg>
  );
};

export default LogoIconSimple; // You can export either version
export { LogoIcon, LogoIconSimple };